/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
    container: {
        color: 'red',
        marginBottom: '10px',
    },
}));

const VaseConfigATCError = () => {
    const classes = useStyles();
    return (
        <div className={classes.container}>
            *Please select another add-on to continue to checkout
        </div>
    );
};

VaseConfigATCError.propTypes = {};

export default VaseConfigATCError;
